import { render, staticRenderFns } from "./MeasuresTable.vue?vue&type=template&id=8e09d0e8&"
import script from "./MeasuresTable.vue?vue&type=script&lang=js&"
export * from "./MeasuresTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports